import type React from "react";
import "./style.css";
import { type AlertType, CloseIcon, InfoTypeIcon } from "~/components/icons";

export type Message = {
	type: AlertType;
	text: string;
};

export interface Props {
	message: Message;
	close: () => void;
}

export const SnackBar: React.FC<Props> = ({ message, close }: Props) => {
	return (
		<div className={`t4-snackbar t4-snackbar-${message.type}`}>
			<div className="icon-container flex flex-col justify-center items-center px-6">
				<InfoTypeIcon
					type={message.type}
					color={{ dark: "white", light: "black" }}
				/>
			</div>
			<div className="t4-snackbar-text grow">
				<span>{message.text}</span>
			</div>
			<button
				type="button"
				className="cursor-pointer flex flex-col justify-center items-center px-6"
				onClick={close}
			>
				<CloseIcon color={{ dark: "white", light: "black" }} />
			</button>
		</div>
	);
};
